import React, { useState } from "react";

import { Input as InputAntd, Form as FormAntd, Button, Select as SelectAntd } from "antd";

import { PlusOutlined } from "@ant-design/icons";

import { LANGUAGE_TYPE_NONE, LANGUAGE_TYPE_SINGLE, LANGUAGE_TYPE_PAIR } from "../../../config/const";

import Prices from "../list";
import ModalPrice from "./modal";

import { v4 } from "uuid";
import { notification } from "antd";

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

const FormPrices = (props) => {
    const [modalVisible, setModalVisible] = useState(false);
    const showModal = () => setModalVisible(true);
    const hideModal = () => setModalVisible(false);
    const [workingPrice, setWorkingPrice] = useState({});

    const createPrice = () => {
        setWorkingPrice({});
        showModal();
    };

    const editPrice = (id) => {
        const { values } = props;
        const price = values.prices.find((e) => e.id == id);
        setWorkingPrice(price);
        showModal();
    };
    const removePrice = (id) => {
        const { values, setFieldValue } = props;

        const newPrices = values.prices.filter((e) => e.id != id);
        setFieldValue("prices", newPrices);

        setFieldValue("prices_updated", true);
    };

    const onSubmit = (values, bag) => {
        let prices = [];
        const price = { ...values, id: values.id ? values.id : v4() };

        if (values.id) {
            prices = (props.values.prices || []).map((item) => (item.id === values.id ? price : item));
        } else {
            prices = [...props.values.prices, price];
        }

        /*

        const pricesWithoutDuplicates = props.values.prices.filter(
            (e) =>
                e.service !== price.service ||
                e.unit !== price.unit ||
                e.category !== price.category ||
                e.languagePair !== price.languagePair ||
                e.language !== price.language ||
                e.languageFamily !== price.languageFamily 
        ).filter(e => e.id !== values.id);
        
        const prices = [...pricesWithoutDuplicates, price];
        */

        props.setFieldValue("prices", prices);

        /*
        const prices = [...props.values.prices, price];

        props.setFieldValue("prices", prices);
        */
        setFieldValue("prices_updated", true);

        hideModal();
        //const ret = props.createEventNotAvailable(values);

        return;
        //ret.then((response) => {
        //    bag.setSubmitting(false);
        //    if (isNotValid(response)) {
        //        bag.setErrors(translateSymfonyErrorToFormik(response.errors.children));
        //    } else {
        //        hideModal();
        //    }
        //}).catch((e) => {
        //alert("Se ha producido un error desconocido");
        //});
    };
    const {
        values,
        errors,
        setFieldValue,

        servicesById,
        categoriesById,
        languagesById,
        languagePairsById,
        units,
        unitsById,
    } = props;

    const services = props.Services;

    const languages = props.strictValues
        ? props.languages.filter((item) => (values.languages || []).indexOf(item?.id) !== -1)
        : props.languages;
    const languagePairs = props.strictValues
        ? props.languagePairs.filter((item) => (values.language_pairs || []).indexOf(item?.id) !== -1)
        : props.languagePairs;

    return (
        <>
            <FormAntd.Item
                label="Prices"
                validateStatus={errors.prices ? "error" : false}
                help={errors.prices ? errors.prices : false}
            >
                {values.prices.length >= 0 && (
                    <Prices
                        servicesById={servicesById}
                        categoriesById={categoriesById}
                        languagesById={languagesById}
                        languagePairsById={languagePairsById}
                        unitsById={unitsById}
                        editPrice={editPrice}
                        removePrice={removePrice}
                        prices={values.prices}
                    />
                )}

                <Button type="dashed" size="small" icon={<PlusOutlined />} onClick={createPrice} block>
                    New
                </Button>
            </FormAntd.Item>

            {modalVisible && (
                <ModalPrice
                    price={workingPrice}
                    handleSubmit={onSubmit}
                    services={props.services}
                    languages={languages}
                    languagePairs={languagePairs}
                    units={props.units}
                    onCancel={hideModal}
                    modalVisible={modalVisible}
                    allowEmptyService={props.allowEmptyService}
                />
            )}
        </>
    );
};

export default FormPrices;
